import * as React from 'react'
import { ReactElement } from 'react'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import CommandButtons from '../../Form/CommandButtons'

export default function AddNoteCommandDialog(): ReactElement {
    return (
        <CommandDialog dialogContentProps={{ title: 'Notitie aanmaken' }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <>
                    Deze functionaliteit is nog in onwikkeling.
                    <CommandButtons dismiss={onDismiss} dismissButton />
                </>
            )}
        </CommandDialog>
    )
}
